import * as Sentry from '@sentry/vue';

const sanitizeHeaders = (headers) => {
  const sensitiveHeaders = ['authorization', 'x-auth-token', 'cookie', 'x-api-key'];

  return Object.entries(headers).reduce((sanitized, [key, headerValue]) => {
    const value = sensitiveHeaders.includes(key.toLowerCase()) ? '[REDACTED]' : headerValue;
    return { ...sanitized, [key]: value };
  }, {});
};

export default (error) => {
  try {
    const errorContext = {
      endpoint: (error.config && error.config.url) || 'Unknown endpoint',
      method: (error.config && error.config.method && error.config.method.toUpperCase()) || 'Unknown method',
      baseURL: (error.config && error.config.baseURL) || 'Unknown base URL',
      fullURL: (error.config && error.config.url) ? error.config.baseURL + error.config.url : 'Unknown URL',
      requestHeaders: (error.config && error.config.headers) || {},
      requestBody: (error.config && error.config.data) || null,
      responseStatus: (error.response && error.response.status) || null,
      responseData: (error.response && error.response.data) || null,
      timestamp: new Date().toISOString(),
    };

    const sanitizedHeaders = sanitizeHeaders(errorContext.requestHeaders);

    Sentry.withScope((scope) => {
      // Set tags for filtering and searching
      scope.setTag('error_type', 'api_error');
      scope.setTag('http_status', errorContext.responseStatus);
      scope.setTag('endpoint', errorContext.endpoint);
      scope.setTag('method', errorContext.method);
      scope.setTag('base_url', errorContext.baseURL);
      scope.setTag('timestamp', errorContext.timestamp);

      scope.setExtra('Request Headers', sanitizedHeaders);


      if (errorContext.requestBody) {
        try {
          const requestBodyJson = JSON.stringify(errorContext.requestBody, null, 2);
          scope.setExtra('Request Body', JSON.parse(requestBodyJson));
        } catch (jsonError) {
          scope.setExtra('Request Body', '[REQUEST_BODY_STRINGIFY_ERROR]');
        }
      }

      if (errorContext.responseData) {
        try {
          const responseDataJson = JSON.stringify(errorContext.responseData, null, 2);
          scope.setExtra('Response Data', responseDataJson);
        } catch (jsonError) {
          scope.setExtra('Response Data', '[RESPONSE_DATA_STRINGIFY_ERROR]');
        }
      }

      scope.setLevel('error');

      Sentry.captureException(error);
    });
  } catch (sentryError) {
    // eslint-disable-next-line no-console
    console.warn('Failed to send error to Sentry:', sentryError);
  }
};




// WEBPACK FOOTER //
// ./src/utils/sentryHelper.js